<div class="floating-spinner" [ngClass]="{ 'active': showSpinner, 'inactive': !showSpinner }">
    <div>
        Work in progress <i class="fa fa-spinner fa-spin"></i>
    </div>
</div>
